module.exports = __webpack_public_path__ + "static/classhook-profile-708aa719b4625cab3ff01c2892e87323.jpg";